import React from "react";
import { useTranslation } from "react-i18next";
import type { StructureType } from "@/types/silae";

/**
 * Hook utilitaire pour déterminer les titres des étapes selon la structure
 */
export const useWizardStepTitles = (wizardStructure: StructureType) => {
  const { t } = useTranslation();

  const stepTitles = React.useMemo(() => {
    const baseTitles = {
      simple: [
        t("wizard.stepIndicator.titles.structure"),
        t("wizard.stepIndicator.titles.configuration"),
      ],
      with_conditions: [
        t("wizard.stepIndicator.titles.structure"),
        t("wizard.stepIndicator.titles.conditions"),
        t("wizard.stepIndicator.titles.configuration"),
      ],
      if_else: [
        t("wizard.stepIndicator.titles.structure"),
        t("wizard.stepIndicator.titles.conditions"),
        t("wizard.stepIndicator.titles.configIf"),
        t("wizard.stepIndicator.titles.configElse"),
      ],
    };

    const endTitles = [
      t("wizard.stepIndicator.titles.validation"),
      t("wizard.stepIndicator.titles.generation"),
    ];

    switch (wizardStructure) {
      case "simple":
        return [...baseTitles.simple, ...endTitles];
      case "with_conditions":
        return [...baseTitles.with_conditions, ...endTitles];
      case "if_else":
        return [...baseTitles.if_else, ...endTitles];
      default:
        return [...baseTitles.simple, ...endTitles];
    }
  }, [wizardStructure, t]);

  return stepTitles;
};

/**
 * Hook utilitaire pour déterminer les descriptions des étapes selon la structure
 */
export const useWizardStepDescriptions = (wizardStructure: StructureType) => {
  const { t } = useTranslation();

  const stepDescriptions = React.useMemo(() => {
    const baseDescriptions = {
      simple: [
        t("wizard.stepIndicator.descriptions.structure"),
        t("wizard.stepIndicator.descriptions.configuration"),
      ],
      with_conditions: [
        t("wizard.stepIndicator.descriptions.structure"),
        t("wizard.stepIndicator.descriptions.conditions"),
        t("wizard.stepIndicator.descriptions.configuration"),
      ],
      if_else: [
        t("wizard.stepIndicator.descriptions.structure"),
        t("wizard.stepIndicator.descriptions.conditions"),
        t("wizard.stepIndicator.descriptions.configIf"),
        t("wizard.stepIndicator.descriptions.configElse"),
      ],
    };

    const endDescriptions = [
      t("wizard.stepIndicator.descriptions.validation"),
      t("wizard.stepIndicator.descriptions.generation"),
    ];

    switch (wizardStructure) {
      case "simple":
        return [...baseDescriptions.simple, ...endDescriptions];
      case "with_conditions":
        return [...baseDescriptions.with_conditions, ...endDescriptions];
      case "if_else":
        return [...baseDescriptions.if_else, ...endDescriptions];
      default:
        return [...baseDescriptions.simple, ...endDescriptions];
    }
  }, [wizardStructure, t]);

  return stepDescriptions;
};
